import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UsersThree, Newspaper, Buildings, ChatCircleText, ArrowRight } from "@phosphor-icons/react";
import api from "../../lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [recentLeads, setRecentLeads] = useState([]);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data));
    api.get("/admin/leads").then(({ data }) => setRecentLeads(data.slice(0, 5)));
  }, []);

  const cards = [
    { label: "Total Leads", value: stats?.leads ?? "—", icon: <UsersThree weight="duotone" size={24}/>, link: "/admin/leads", color: "bg-[#135934]" },
    { label: "Blog Posts", value: stats?.blogs ?? "—", icon: <Newspaper weight="duotone" size={24}/>, link: "/admin/blogs", color: "bg-[#0F52BA]" },
    { label: "Projects", value: stats?.projects ?? "—", icon: <Buildings weight="duotone" size={24}/>, link: "/admin/projects", color: "bg-[#FDB813]" },
    { label: "Testimonials", value: stats?.testimonials ?? "—", icon: <ChatCircleText weight="duotone" size={24}/>, link: "/admin/testimonials", color: "bg-[#0A1F15]" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-8">
        <h1 className="h2 text-[#0A1F15]">Dashboard</h1>
        <p className="text-[#5C7368]">Overview of your Orax Solar website.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {cards.map((c, i) => (
          <Link key={i} to={c.link} className="bg-white rounded-2xl p-5 border border-[#E5E3DB] card-lift block">
            <div className={`w-10 h-10 rounded-lg ${c.color} text-white flex items-center justify-center mb-3`}>{c.icon}</div>
            <div className="font-display font-extrabold text-3xl text-[#0A1F15]">{c.value}</div>
            <div className="text-sm text-[#5C7368]">{c.label}</div>
          </Link>
        ))}
      </div>

      <div className="bg-white rounded-2xl border border-[#E5E3DB] overflow-hidden">
        <div className="p-5 border-b border-[#E5E3DB] flex items-center justify-between">
          <h2 className="h3 text-[#0A1F15]">Recent Leads</h2>
          <Link to="/admin/leads" className="text-sm text-[#0F52BA] font-semibold flex items-center gap-1">
            View all <ArrowRight size={14}/>
          </Link>
        </div>
        {recentLeads.length === 0 ? (
          <div className="p-10 text-center text-[#5C7368]">No leads yet.</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-[#F9F8F6] text-left text-[#5C7368] uppercase text-xs tracking-wider">
                <tr>
                  <th className="px-5 py-3">Name</th>
                  <th className="px-5 py-3">Phone</th>
                  <th className="px-5 py-3">City</th>
                  <th className="px-5 py-3">Bill</th>
                  <th className="px-5 py-3">Source</th>
                  <th className="px-5 py-3">Date</th>
                </tr>
              </thead>
              <tbody>
                {recentLeads.map(l => (
                  <tr key={l.id} className="border-t border-[#E5E3DB]">
                    <td className="px-5 py-3 font-semibold text-[#0A1F15]">{l.name}</td>
                    <td className="px-5 py-3">{l.phone}</td>
                    <td className="px-5 py-3">{l.city || "—"}</td>
                    <td className="px-5 py-3">{l.electricity_bill || "—"}</td>
                    <td className="px-5 py-3"><span className="text-xs px-2 py-0.5 rounded-md bg-[#F0EFEB]">{l.source || "—"}</span></td>
                    <td className="px-5 py-3 text-[#5C7368]">{new Date(l.created_at).toLocaleDateString("en-IN")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
